import { SearchInput } from "@src/features/table_filtering/components/search_input";

interface ChangelogTabToolBarProps {
  onQuickFilter: (quickSearch: string) => void;
  disabled: boolean;
}

const ChangelogTabToolBar: React.FC<ChangelogTabToolBarProps> = ({
  onQuickFilter,
  disabled,
}) => {
  return (
    <div className="tool-bar">
      <div className="tool-bar__button-section">
        <SearchInput
          onChange={onQuickFilter}
          disabled={disabled}
          title="changelog"
        />
      </div>
    </div>
  );
};

export default ChangelogTabToolBar;
